"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MirrorStockImpl__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "randomGeneratorAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b5060928061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c80638ea4031114602d575b600080fd5b612afb546040906001600160a01b031681565b6040516001600160a01b03909116815260200160405180910390f3fea2646970667358221220a0b0dbdac1bb33d7d12d04a46f6dd0e6da1f4b2b3a83de7d531f09599ecde85864736f6c63430008020033";
class MirrorStockImpl__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MirrorStockImpl__factory = MirrorStockImpl__factory;
MirrorStockImpl__factory.bytecode = _bytecode;
MirrorStockImpl__factory.abi = _abi;
//# sourceMappingURL=MirrorStockImpl__factory.js.map